import React from "react";
import "../ui/ui.scss";

/**
 * EmptyState — Centered placeholder for empty data sections.
 *
 * Props:
 *   icon        — React node (icon displayed in circle)
 *   title       — Main heading
 *   description — Subtitle text
 *   action      — React node (button/link below text)
 *   className   — Extra class
 */
const EmptyState = ({ icon, title, description, action, className = "" }) => (
  <div className={`ui-empty ${className}`}>
    {icon && <div className="ui-empty__icon">{icon}</div>}
    {title && <div className="ui-empty__title">{title}</div>}
    {description && <div className="ui-empty__desc">{description}</div>}
    {action && <div className="ui-empty__action">{action}</div>}
  </div>
);

export default EmptyState;
